const regexpPatterns = {
  /**
   * Allowed formats:
   * 1. +1 (234) 567 8901
   * 2. (123) 456 7890
   * 3. +44 (123) 4567 8901
   * 4. 123456789012345
   * 5. +123456789012345
   *
   * reference: https://stackoverflow.com/a/18091377
   */
  phoneNumberValidator: /\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/,
  emailValidator: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

  /**
   * 1. At least one digit must be present.
   * 2. At least one lowercase letter must be present.
   * 3. At least one uppercase letter must be present.
   * 4. Ensures that at least one letter is present (either lowercase or uppercase).
   * 5. The password must be at least 8 characters long.
   */
  passwordValidator: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
};

export default regexpPatterns;
